function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#C3C3C3",
  transform: "translate(2.305 1)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M4.95 5h31.706c2.734 0 4.95 2.09 4.95 4.668v65.614c0 2.578-2.216 4.668-4.95 4.668H4.95C2.216 79.95 0 77.86 0 75.282V9.668C0 7.09 2.216 5 4.95 5zM1.234 25.533H29.72 1.234zm0-9.128H29.72 1.234zm0 18.904h20.104H1.234zm0 9.776h20.104H1.234zm0 9.776h13.358H1.234z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M58.94 27.044c2.735 0 4.95 2.09 4.95 4.668v43.57c0 2.578-2.215 4.668-4.95 4.668H41.836c-2.734 0-.336-2.09-.336-4.668 0-1.719.04-14.129.12-37.23 0-2.578-.025-4.959.002-11.008h17.32zm3.65 9.703H42.215 62.59zm0 8.817H42.636 62.59zm0 8.818H49.33 62.59z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58.076,
  cy: 10.38,
  r: 9.88,
  fill: "#FFF",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C3C3C3",
  fillRule: "nonzero",
  d: "M61.692 9.662c.195 0 .36.07.494.213a.71.71 0 0 1 .202.505.71.71 0 0 1-.202.506.655.655 0 0 1-.494.213h-2.897v2.897c0 .195-.071.36-.213.495a.71.71 0 0 1-.506.202.71.71 0 0 1-.505-.202.655.655 0 0 1-.214-.495V11.1H54.46a.655.655 0 0 1-.494-.213.71.71 0 0 1-.202-.506.71.71 0 0 1 .202-.505.655.655 0 0 1 .494-.213h2.897V6.764c0-.194.072-.359.214-.494a.71.71 0 0 1 .505-.202.71.71 0 0 1 .506.202c.142.135.213.3.213.494v2.898h2.897z"
}));

const SvgLocationIconBig = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 83,
    viewBox: "0 0 72 83",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocationIconBig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location-icon-big.5a97b27c.svg";
export { ForwardRef as ReactComponent };